import React, { useCallback } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./LanguageBar.module.scss";
import withTheme from "../../../libs/themr/withTheme";

const LanguageSelectItem = ({ theme, language, isSelected, handleClick }) => {
  const onClick = useCallback(() => {
    handleClick(language.name);
  }, [handleClick, language]);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <li onClick={onClick} className={cx({ [theme.selected]: isSelected })}>
      <span className={theme.languageName}>{language.displayName}</span>
    </li>
  );
};

LanguageSelectItem.propTypes = {
  language: PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired
};

export default withTheme(styles)(React.memo(LanguageSelectItem));
